import { jsxs } from "react/jsx-runtime";
import { c } from "react-compiler-runtime";
import classnames from "classnames";
import { Box } from "../Box/index.js";
import { CounterBackgroundColor, CounterSize } from "./Counter.types.js";
import { useStyles } from "./Counter.styles.js";
const Counter = (t0)=>{
    const $ = c(15);
    const { backgroundColor: t1, className, color, counter, signed: t2, size: t3, moreThanMax: t4, borderRadius: t5, testId: t6 } = t0;
    const backgroundColor = void 0 === t1 ? "white" : t1;
    const signed = void 0 === t2 ? false : t2;
    const size = void 0 === t3 ? "medium" : t3;
    const moreThanMax = void 0 === t4 ? false : t4;
    const borderRadius = void 0 === t5 ? "s" : t5;
    const testId = void 0 === t6 ? "counter" : t6;
    const t7 = CounterBackgroundColor[backgroundColor];
    const t8 = CounterSize[size];
    let t9;
    if ($[0] !== borderRadius || $[1] !== color || $[2] !== signed || $[3] !== t7 || $[4] !== t8) {
        t9 = {
            backgroundColor: t7,
            color,
            size: t8,
            signed,
            borderRadius
        };
        $[0] = borderRadius;
        $[1] = color;
        $[2] = signed;
        $[3] = t7;
        $[4] = t8;
        $[5] = t9;
    } else t9 = $[5];
    const { classes } = useStyles(t9);
    const sign = signed && Number(counter) > 0 ? "+" : "";
    let t10;
    if ($[6] !== className || $[7] !== classes.counter) {
        t10 = classnames(classes.counter, className);
        $[6] = className;
        $[7] = classes.counter;
        $[8] = t10;
    } else t10 = $[8];
    const t11 = moreThanMax ? "+" : "";
    let t12;
    if ($[9] !== counter || $[10] !== sign || $[11] !== t10 || $[12] !== t11 || $[13] !== testId) {
        t12 = /*#__PURE__*/ jsxs(Box, {
            testId: testId,
            className: t10,
            children: [
                sign,
                counter,
                t11
            ]
        });
        $[9] = counter;
        $[10] = sign;
        $[11] = t10;
        $[12] = t11;
        $[13] = testId;
        $[14] = t12;
    } else t12 = $[14];
    return t12;
};
export { Counter };
